import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import { gaEventTracker } from "@util/helpers";

import { contactFormUrl, newspostUrl, nonSphText, sphText } from "./constants";
import { ArticlePurchaseLinkProps } from "./types";

export default function ArticlePurchaseLinkVersion2({
  title,
  publishedDate,
  displayPurchase,
}: ArticlePurchaseLinkProps): React.ReactElement {
  const date = encodeURIComponent(publishedDate);
  const encodedTitle = encodeURIComponent(title);

  const onClickTriggerGa = (eventLabel: string) => {
    const eventCategory = displayPurchase ? "copyright" : "feedback";
    gaEventTracker(eventCategory, "click", eventLabel);
  };

  return (
    <section
      className="mx-auto flex w-full items-center justify-between gap-4 lg:gap-0"
      data-testid="article-purchase-link-version-2-component"
    >
      <p className="mb-0 font-public-sans text-xs tracking-normal">
        {displayPurchase ? sphText : nonSphText}
      </p>

      <div className="flex flex-wrap">
        {displayPurchase ? (
          <ButtonFactory
            buttonType={ButtonType.Link}
            onClick={() => {
              onClickTriggerGa("purchase article");
            }}
            link={`${newspostUrl}?publication=BT&title=${encodedTitle}&date=${date}`}
            mask={ButtonType.Secondary}
            text="Reuse this content"
            className="w-fit-content mr-4 !no-underline"
          />
        ) : null}

        <ButtonFactory
          buttonType={ButtonType.Link}
          onClick={() => {
            onClickTriggerGa("contact us");
          }}
          link={contactFormUrl}
          mask={ButtonType.Secondary}
          text="Feedback"
          className="w-fit-content !no-underline"
        />
      </div>
    </section>
  );
}
